import { array, mixed, object, string } from 'yup';

import { translate } from '@utils/locale';
import { RegularExpressions } from '@constants/common';

export const createCompanySchema = object({
  //Legal info
  companyRegisteredName: string()
    .required(translate('company.placeholders.companyRegisteredName'))
    .test(
      'required',
      translate('company.placeholders.companyRegisteredName'),
      val => !!val.trimEnd()
    ),
  cin: string()
    .required(translate('company.placeholders.uniqueId'))
    .test(
      'required',
      translate('company.placeholders.uniqueId'),
      val => !!val.trimEnd()
    ),
  registrationNumber: string().required(
    translate('company.placeholders.uniqueId')
  ),
  incorporationCountry: string().required(translate('requiredInput')),
  currency: string().nullable(),
  //Address
  addressLine1: string().nullable(),
  addressLine2: string().nullable(),
  city: string().nullable(),
  state: string().nullable(),
  country: string().required(translate('requiredInput')),
  pin: string().nullable(),
  timezone: string().nullable(),
  //Brand
  companyBrandName: string()
    .required(translate('company.placeholders.companyBrandName'))
    .test(
      'required',
      translate('company.placeholders.companyBrandName'),
      val => !!val.trimEnd()
    ),
  website: string().url(translate('deals.invalidUrl')).nullable(),
  companyLogo: mixed()
    .required(translate('company.placeholders.companyLogo'))
    .test(
      'requiredValidation',
      translate('company.placeholders.companyLogo'),
      (value: { file: File }) => {
        return !!value?.file;
      }
    ),
  companyStage: string().required(
    translate('company.placeholders.companyStage')
  ),
  sector: string().required(translate('company.placeholders.sector')),
  companyOneLiner: string().max(35).nullable(),
  detailedDescription: string().nullable(),
  companyEmailDomains: array().of(string()),
  hexValue: string()
    .matches(
      RegularExpressions.hexColorRegex,
      translate('company.placeholders.hexValueError')
    )
    .required(translate('company.placeholders.hexValue'))
});
